<template>
	<b-jumbotron fluid header-level="4" class="d-flex d-flex-column justify-content-center h-100 w-100 flex-grow-1 text-bold m-0 align-items-center"
		:style="'background: url(' + variantBackground() + ') no-repeat center fixed; background-size: cover;'">
		<b-row class="justify-content-center">
			<b-col md="10" lg="6" xl="6">
				<b-card v-if="$slots['WelcomeMessage'] || $slots['MiscContent'] || DisplayBrand || Loading" style="opacity: 0.9">
					<!-- S'il y a le slot WelcomeMessage est défini alors on affiche le b-card-title complet -->
					<b-card-title>
						<b-row>
							<b-col class="pt-0 pb-2 h1 text-center">
								<!-- Message de bienvenue vide par défaut -->
								<slot name="WelcomeMessage" />

								<div v-if="DisplayBrand" class="font-weight-bold">DeltaConso Expert</div>
								
								<b-img v-if="Loading" height="150rem" width="150rem" center :src="AbsoluteLink('Images/Dcx_Loading.png')" />
							</b-col>
						</b-row>
					</b-card-title>
					<b-card-text v-if="DisplayBrand">
						<b-row class="text-center">
							<b-col>
								<h5><span class="text-gray-dark">{{ $t('ControlEnergyConsumption') }}</span></h5><!-- Maîtrisez vos consommations énergétiques -->
							</b-col>
						</b-row>
					</b-card-text>
					<b-card-footer class="p-0">
						<!-- Message de chargement-->
						<h4 v-if="Loading" class="text-center">{{ $t('LoadingInProgress') }}</h4>
						<slot name="MiscContent" />
					</b-card-footer>
				</b-card>
			</b-col>
		</b-row>
	</b-jumbotron>
</template>

<script lang="ts">
	import { Prop } from 'vue-property-decorator';
	import Component, { mixins } from 'vue-class-component';
	import { LinkUtils, StringUtils } from '@/components/commons/Utils';
	import locales from "./locales/Welcome.json";

	/** Composant de bannière de page d'acceuil */
	@Component({
		components: { },
		i18n:{ messages: locales }
    })
    export default class Welcome extends mixins(LinkUtils, StringUtils) {
		/** 
		 * Indique si le nom du produit et le slogan sont affichés ou non
		 * @default true
		 * */
		@Prop({ default: () => true })
		public DisplayBrand!: boolean;

		/** 
		 * Indique si l'image Dcx de loading est affiché ou non
		 * @default false
		 */
		@Prop({ default: () => false })
		public Loading!: boolean;

		/** Variant de couleur à appliquer sur le composant */
		@Prop({ default: () => "secondary" })
		public Variant!: string;

		/** 
		 * Retourne l'arrière-plan à appliquer en fonction du Variant de couleur
		 * @todo Gérer le dark mode
		 */
		private variantBackground() {
			return this.AbsoluteLink("Images/WelcomeLight" + this.capitalize(this.Variant) + ".webp");
		}
	}
</script>

<style scoped>

</style>